import React from "react";
import { Select, Input } from "antd";
import countries from "./countries";
import "./phone-input.css";

const { Option } = Select;

const PhoneInput = ({ value = {}, onChange, className = "" }) => {
  const { country, number = "" } = value;

  if (!country) return null;

  const triggerChange = (changed) => {
    onChange?.({
      country,
      number,
      ...changed,
    });
  };

  return (
    <div className={`phone-input-wrapper ${className}`.trim()}>
      <Select
        showSearch
        className="country-select"
        value={country.iso}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        optionLabelProp="label"
        onChange={(iso) =>
          triggerChange({
            country: countries.find((c) => c.iso === iso),
          })
        }
        optionFilterProp="children"
      >
        {countries.map((c) => (
          <Option
            key={c.iso}
            value={c.iso}
            label={
              <>
                <img
                  src={c.flagSvg}
                  width={18}
                  style={{ marginRight: 8 }}
                  alt={c.iso}
                />
                ({c.dialCode})
              </>
            }
          >
            <img
              src={c.flagSvg}
              width={18}
              style={{ marginRight: 8 }}
              alt={c.iso}
            />
            {c.name} ({c.dialCode})
          </Option>
        ))}
      </Select>

      <Input
        className="number-input-new"
        value={number}
        placeholder="Phone number"
        onChange={(e) =>
          triggerChange({
            number: e.target.value.replace(/\D/g, ""),
          })
        }
      />
    </div>
  );
};

export default PhoneInput;
